import moment from "moment";
import { Alert } from "types";
import _ from "lodash";
import { DATE_FORMAT } from "shared/constants";
export const isAlertDisabled = (alert: Alert) => {
  return !!alert.disabled;
};

export const isAlertExpired = (alert: Alert) => {
  if (!alert){
    return false;
  }
  return moment().diff(moment(alert.end_date, DATE_FORMAT), "d") > 0;
};
export const getAlertDaysDiff = (alert: Alert) => {
  if (alert && moment().diff(moment(alert.end_date, DATE_FORMAT), "d") > 0) {
    return alert
      ? 0 - moment().diff(moment(alert.end_date, DATE_FORMAT), "d")
      : null;
  } else {
    return alert
      ? moment(alert.end_date, DATE_FORMAT).diff(
          moment(alert.start_date, DATE_FORMAT),
          "d"
        )
      : null;
  }
};
/*
  This return the first day in the month (e.g.: 2017-01-01 00:00:00) of the alerts expiration date
  written as unix time
*/
export const getAlertExpirationMonth = (alert: Alert) => {
  return moment(alert.end_date, DATE_FORMAT)
    .startOf("month")
    .unix();
};

export function groupByExpirationStatus(alerts: Alert[]) {
  const grouped = _.groupBy(
    alerts,
    a => (isAlertExpired(a) || isAlertDisabled(a) ? "expired" : "active"),
  );
  return grouped;
}
export function groupByExpirationMonth(alerts: Alert[]) {
  return _.groupBy(alerts, getAlertExpirationMonth);
}

export const groupByMonth = (alerts: Alert[]) => {
  return _(groupByExpirationMonth(alerts))
    .mapKeys((alert, unix) => moment.unix(unix as any).format("MMMM YYYY"))
    .value();
};



// WEBPACK FOOTER //
// ./src/pages/alertList/util.ts